import { PostState } from '@/composition/posts'
import { emitter } from '@/main'
import { IComments } from '@/models/Comments'
import { IPosts } from '@/models/Posts'
import { getHostName } from '@ghl/clientportal-core'
import { Router } from 'vue-router'

export function handleCardClick(post: IPosts, router: Router): void {
  if (
    router.currentRoute.value.name === 'home' ||
    router.currentRoute.value.name === 'to-review'
  ) {
    router.push({
      name: 'group-post-view',
      params: {
        postId: post._id,
      },
    })
  } else if (router.currentRoute.value.name === 'channel-overview') {
    router.push({
      name: 'channel-post-view',
      params: {
        postId: post._id,
      },
    })
  } else if (router.currentRoute.value.name === 'group-home-search') {
    /** forward the query params to the new route */
    const query = router.currentRoute.value.query
    router.push({
      name: 'group-search-post-view',
      params: {
        postId: post._id,
      },
      query,
    })
  } else if (router.currentRoute.value.name === 'channel-search') {
    /** forward the query params to the new route */
    const query = router.currentRoute.value.query
    router.push({
      name: 'channel-search-post-view',
      params: {
        postId: post._id,
      },
      query,
    })
  } else {
    router.push({
      name: 'user-post-view',
      params: {
        postId: post._id,
        userSlug: post.user.slug,
      },
    })
  }
}

export function handleCommentCardClick(
  comment: IComments,
  router: Router
): void {
  if (router.currentRoute.value.name === 'group-home-search') {
    const query = router.currentRoute.value.query
    router.push({
      name: 'group-search-post-view',
      params: {
        postId: comment.postId,
      },
      query: { ...query, commentId: comment._id, parentId: comment.parentId },
    })
  } else if (router.currentRoute.value.name === 'channel-search') {
    const query = router.currentRoute.value.query
    router.push({
      name: 'channel-search-post-view',
      params: {
        postId: comment.postId,
      },
      query: { ...query, commentId: comment._id, parentId: comment.parentId },
    })
  }
}

export async function handleShareClick(
  post: IPosts,
  router: Router
): Promise<void> {
  let postLink = `https://${getHostName()}${
    router.currentRoute.value.fullPath
  }/posts/${post._id}`

  if (
    router.currentRoute.value.name &&
    [
      'channel-post-view',
      'group-post-view',
      'user-post-view',
      'channel-search-post-view',
      'group-search-post-view',
    ].includes(router.currentRoute.value.name as string)
  )
    postLink = `https://${getHostName()}${router.currentRoute.value.fullPath}`
  await navigator.clipboard.writeText(postLink)
}

export function getShareablePostLink(post: IPosts, router: Router): string {
  let postLink = `https://${getHostName()}${
    router.currentRoute.value.fullPath
  }/posts/${post._id}`

  if (
    router.currentRoute.value.name &&
    [
      'channel-post-view',
      'group-post-view',
      'user-post-view',
      'channel-search-post-view',
      'group-search-post-view',
    ].includes(router.currentRoute.value.name as string)
  )
    postLink = `https://${getHostName()}${router.currentRoute.value.fullPath}`
  return postLink
}

export function getTextContent(htmlContent?: string): string {
  if (htmlContent) {
    return htmlContent
      .replace(/<(?!\/?(a|span)(?=>|\s.*>))[^>]+>/g, '\n')
      .trim()
  } else {
    return ''
  }
}

export function getTextContentForValidation(htmlContent?: string): string {
  if (htmlContent) {
    return htmlContent
      .replace(/<(?!\/?(a|span|img)(?=>|\s.*>))[^>]+>/g, '\n')
      .trim()
  } else {
    return ''
  }
}

export async function deletePost(post: IPosts): Promise<void> {
  if (post.channelPinnedIndex != undefined) {
    await PostState.unpinPostFromChannelTimeline(
      post._id as string,
      post.channelSlug
    )
  }
  if (post.homePinnedIndex != undefined) {
    await PostState.unpinPostFromHomeTimeline(
      post._id as string,
      post.channelId
    )
  }
  await PostState.deletePost(post._id as string)
  emitter.emit('close-postview-modal')
}
